<template>
  <div
    :class="{
      [$style.personComponent]: true,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
  >
    <div :class="$style.wrapper">
      <div :class="$style.roundedWrap" v-html="msg"></div>
      <img
        :class="$style.cornerBottom"
        src="@/assets/images/bubble-corner-top.svg"
      />
      <img
        :class="$style.cornerTop"
        src="@/assets/images/bubble-corner-top.svg"
      />
    </div>

    <!-- note: new design -->
    <!-- <div :class="$style.imgBox" v-if="isNewDesign">
      <img :class="$style.img" :src="getImg('png')" alt="Lisa image" />
    </div> -->

    <picture :class="$style.imgBox">
      <source :srcset="getImg('webp')" type="image/webp" />
      <source :srcset="getImg('png')" type="image/png" />
      <img :src="getImg('png')" alt="Lisa image" />
    </picture>
  </div>
</template>

<script>
import store from '@/store'

export default {
  props: ['slideName'],
  computed: {
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    messages() {
      return store.state.messages
    },
    slide() {
      return store.getters['slideByName'](this.slideName)
    },
    hausType() {
      return store.state.hausType
    },
    msg() {
      let varMsg = ''

      if (this.messages.find(m => m.name === this.slide.slideName)) {
        varMsg = this.messages.find(m => m.name === this.slide.slideName)
          .messages[this.hausType]
      }
      return this.slide.msg.replace('<VAR>', varMsg)
    },
    el() {
      return store.state.el
    }
  },
  methods: {
    getImg(type) {
      return require('../assets/images/' + this.slide.img + '.' + type)
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.personComponent {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper {
  display: flex;
  justify-content: center;
  position: relative;
  background: $color_bg_light;
  border-radius: 10px;
  width: 100%;
  padding: 15px 10px;
  line-height: 1.2;
  font-size: 20px;
  text-align: center;

  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  .roundedWrap {
    width: 100%;
    height: 100%;
  }
  .cornerTop {
    display: none;
  }
  .cornerBottom {
    position: absolute;
    width: 30px;
    bottom: 0;
    left: 50%;
    transform: rotate(180deg) translate(40%, -97%);
  }
}

.imgBox {
  // width: 515px;
  flex: 0 0 70%;
  // margin-top: auto;

  img {
    width: 100%;
  }
}

// note: LAND

// note: PORT
.port {
  &.personComponent {
    margin-bottom: 0px;
    .imgBox {
      flex: 0 0 20%;
    }
    .cornerBottom {
      display: none;
    }
  }
}

// note: PHONE
.phone {
  display: flex;
  width: auto;
  flex-direction: column-reverse;
  margin-bottom: 20px;
  .textBox {
    margin-top: 0px;
    margin-top: -175px;
    min-height: 178.47px;
    margin-bottom: 34px;
  }
  .roundedWrap {
    font-size: 16px;
  }
  .wrapper {
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    .cornerBottom {
      display: block;
      position: absolute;
      transform: rotate(0) translate(-50%, -97%);
      width: 30px;
      top: 0;
      right: 0px;
    }
  }

  .imgBox {
    max-width: 230px;
    // margin: 49px auto;
    img {
      width: 100%;
      display: block;
      // margin: 20px auto;
      // margin-bottom: 95px;
    }
  }
}
</style>
